import { endpoint, dateToServer } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/miniCalculators';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'care';

/**
 * Multipliers Mini Calculator Endpoints:
 */
export default {
    /**
     * Load the care rates
     *
     * @returns {*}
     */
    careRates() {
        return endpoint(`${PARENT}/${RESOURCE}`, 'load');
    },
    findPeriods(carePeriod) {
        return endpoint(`${PARENT}/${RESOURCE}`, 'find-periods', { carePeriod });
    }
};



// WEBPACK FOOTER //
// ./src/services/api/mini-calculators/care.js